<template>
  <span class="ps-badge" :class="'ps-badge--' + badgeType">
    <span class="ps-badge__icon" v-if="showIcon">{{ iconText }}</span>
    {{ label }}
  </span>
</template>

<script>
import { AUDIT_STATE_META } from "./moduleConfig.js";

export default {
  name: "StatusBadge",
  props: {
    /** 主单 auditState：0/1/2/3 或已是文案 */
    status: {
      type: [String, Number],
      default: "",
    },
    /** 直接指定徽标色：green | orange | red | gray | blue */
    type: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    meta() {
      const key = String(this.status);
      return AUDIT_STATE_META[key] || null;
    },
    badgeType() {
      if (this.type) return this.type;
      return (this.meta && this.meta.badge) || "gray";
    },
    label() {
      if (this.text) return this.text;
      return (this.meta && this.meta.text) || String(this.status || "-");
    },
    iconText() {
      const map = {
        green: "✔",
        orange: "🕘",
        red: "✖",
        gray: "📝",
        blue: "●",
      };
      return map[this.badgeType] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.ps-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  &--green {
    background: #dcfce7;
    color: #15803d;
  }
  &--orange {
    background: #ffedd5;
    color: #c2410c;
  }
  &--red {
    background: #fee2e2;
    color: #b91c1c;
  }
  &--gray {
    background: #f3f4f6;
    color: #4b5563;
  }
  &--blue {
    background: #dbeafe;
    color: #1d4ed8;
  }
}
</style>
